import { ILogger } from 'js-logger';

import { logger } from '@gem/modules/logger';
import { WsNetworkError } from '@gem/modules/wsClient/wsErrors';
import { NetworkEventType } from '@gem/modules/wsClient/wsServices';

import {
  WsUntrustedResponse,
  WsUntrustedRequest,
} from 'APP/wsApi/wsAppApi/types/websocket_untrusted_pb';

import { UntrustedWsAppApiNetworkService } from './UntrustedWsAppApiNetworkService';

interface WsEventMessage {
  id: string;
  message: WsUntrustedResponse | WsUntrustedRequest;
}

export class UntrustedWsAppLog {
  private workspace = 'WsApp';
  private unsubscribes: Array<() => void>;

  constructor(private wsNetworkService: UntrustedWsAppApiNetworkService) {
    this.init();
  }

  get logWorkspace(): ILogger {
    return logger.get(this.workspace);
  }

  public init(): void {
    const networkServiceUnsubscribe = this.wsNetworkService.onWsLog(
      ({ message }: WsEventMessage) => {
        if (message.type.case === 'request') {
          this.logWorkspace.log(
            `%c${message.type.value.type.case}%c -> Request`,
            'color: #5698d6; font-size: 1em; font-weight: bold;',
            'color: #bf912c',
            message.type.value.requestId,
            message.type.value.type.value
          );
          return;
        }

        if (message.type.case === 'event') {
          this.logWorkspace.log(
            `%c${message.type.value.type.case}%c Realtime event`,
            'color: #5698d6; font-size: 1em; font-weight: bold;',
            'color: #a04ac2',
            message.type.value.type.value
          );
          return;
        }

        if (message.type.case === 'response') {
          this.logWorkspace.log(
            `%c${message.type.value.type.case}%c <- Response`,
            'color: #5698d6; font-size: 1em; font-weight: bold;',
            'color: #30964b',
            message.type.value.requestId,
            message.type.value.type.value?.type
          );
          return;
        }
      }
    );

    const wsNetworkErrorUnsubscribe = this.wsNetworkService.on(
      NetworkEventType.NetworkError,
      (error: WsNetworkError) => {
        this.logWorkspace.log(
          `%cNetworkError ${error.code}:`,
          'color: #a83b3d; font-size: 1em; font-weight: bold;',
          error.message
        );
      }
    );

    const wsNetworkOpenUnsubscribe = this.wsNetworkService.on(NetworkEventType.Open, () => {
      this.logWorkspace.log(`%cSocket Open`, 'color: #99ab3e; font-size: 1em; font-weight: bold;');
    });

    const wsNetworkCloseUnsubscribe = this.wsNetworkService.on(
      NetworkEventType.Close,
      (event: CloseEvent) => {
        this.logWorkspace.log(
          `%cSocket Close`,
          'color: #ab3e75; font-size: 1em; font-weight: bold;',
          event
        );
      }
    );

    this.unsubscribes = [
      networkServiceUnsubscribe,
      wsNetworkErrorUnsubscribe,
      wsNetworkOpenUnsubscribe,
      wsNetworkCloseUnsubscribe,
    ];
  }

  public detach(): void {
    this.unsubscribes.forEach((unsubscribe) => {
      unsubscribe();
    });
    this.unsubscribes = [];
  }
}
